/* loaded by smart-asset */
export default require("./assets/pallet-downstacking.i.svg")